/*
    SUMMARY

    0 - functions
    1 - Href Anchor
    2 - Menus Anchor
        2.1 - desktop
        2.2 - mobile
        2.3 - Internal
*/

export default function anchorLinks() {

    /*-------------------- 0 - functions --------------------*/
    function setSmoothScrollTo(endX, endY, duration) {
        const startX = window.scrollX || window.pageXOffset;
        const startY = window.scrollY || window.pageYOffset;
        const distanceX = endX - startX;
        const distanceY = endY - startY;
        const startTime = new Date().getTime();

        duration = typeof duration !== "undefined" ? duration : 400;

        const easeInOutQuart = (time, from, distance, duration) => {
            if ((time /= duration / 2) < 1)
                return (distance / 2) * time * time * time * time + from;
            return (-distance / 2) * ((time -= 2) * time * time * time - 2) + from;
        };

        const timer = setInterval(() => {
            const time = new Date().getTime() - startTime;
            const newX = easeInOutQuart(time, startX, distanceX, duration);
            const newY = easeInOutQuart(time, startY, distanceY, duration);
            if (time >= duration) {
                clearInterval(timer);
            }
            window.scroll(newX, newY);
        }, 1000 / 60);
    }

    function openCloseMenu() {
        const menu = document.querySelector('#menu--mobile')
        menu.classList.toggle("isOpen")
    }

    /*-------------------- 1 - Href Anchor ------------------*/
    let prevHref

    window.onload = () => {
        const url = window.location.href

        const arrayUrl = url.split("")

        arrayUrl.forEach((element, index) => {
            // Initial index array
            let initialIndex
            // Array lenght
            const finalIndex = arrayUrl.length
            if (element === '#') {
                // inital index when includes #
                initialIndex = index + 1
                // Set just id array
                const idArray = (arrayUrl.slice(initialIndex, finalIndex))
                // Join href page
                prevHref = arrayUrl.slice(0, index).join('')
                // Join idArray
                const converteToStringIdArray = idArray.join('')
                const id = converteToStringIdArray
                // Get header height
                let headerHeight = document.querySelector('.header--container').clientHeight + 50
                // Verify - mobile or desktop 
                if (window.screen.width < 800) {
                    // Get element with id = 'id'
                    var targetOffset = document.getElementById(id).offsetTop
                    // Scroll Animate
                    setTimeout(() => {
                        $('html, body').animate({
                            scrollTop: targetOffset - headerHeight
                        }, 1000);
                    }, 1500)
                } else {
                    // Get element with id = 'id'
                    if (id !== 'contato') {
                        var targetOffset = (document.getElementById(id).offsetTop - (headerHeight + 50)) * 0.8
                        // Scroll animate
                        setSmoothScrollTo(0, targetOffset, 1000)
                    } else {
                        var targetOffset = (document.getElementById(id).offsetTop) * 0.8
                        setSmoothScrollTo(0, targetOffset, 1000)
                    }
                }

            }
        })
    }

    /*-------------------- 2 - Menus Anchor -----------------*/
    ////// 2.2 - mobile 
    //menu
    const anchorsMenuMobile = document.querySelectorAll(".menu--container .anchor--link")
    anchorsMenuMobile.forEach(element => {
        element.addEventListener("click", (event) => {
            event.preventDefault()
            const id = event.target.getAttribute('href')
            const headerHeight = document.getElementById('header').clientHeight / 3
            var targetOffset = document.querySelector(id).offsetTop
            openCloseMenu()
            // Scroll animate
            $('html, body').animate({
                scrollTop: targetOffset - headerHeight
            }, 1000);
        })
    })

    ////// 2.1 - desktop
    const anchorsMenuDesktop = document.querySelectorAll("header .anchor--link")
    anchorsMenuDesktop.forEach((element) => {
        element.addEventListener("click", (event) => {
            event.preventDefault()
            const id = element.getAttribute('href')
            // header height
            const headerHeight = document.querySelector('.header--container').clientHeight
            // Code... ^
            // Join idArray

            // Get element with id = 'id'

            if (id === '#home') {
                setSmoothScrollTo(0, 0, 1000)
            }

            if (id !== '#contato') {
                var targetOffset = (document.querySelector(id).offsetTop - (headerHeight + 50)) * 0.8
                // Scroll animate
                setSmoothScrollTo(0, targetOffset, 1000)
            } else {
                var targetOffset = (document.querySelector(id).offsetTop) * 0.8
                setSmoothScrollTo(0, targetOffset, 1000)
            }

        })
    })

    ////// 2.3 - Internal
    if (window.screen.width < 800) {
        const anchorsMobile = document.querySelectorAll(".anchor--link")
        anchorsMobile.forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault()
                const id = element.getAttribute('href')
                // header height
                const headerHeight = document.querySelector('.header--container').clientHeight
                // Code... ^
                // Join idArray

                // Get element with id = 'id'

                var targetOffset = (document.querySelector(id).offsetTop)

                $('html, body').animate({
                    scrollTop: targetOffset - headerHeight
                }, 1000);

            })
        })
    } else {
        const anchorsDesktop = document.querySelectorAll(".anchor--link")
        anchorsDesktop.forEach((element) => {
            element.addEventListener("click", (event) => {
                event.preventDefault()
                const id = element.getAttribute('href')
                // header height
                const headerHeight = document.querySelector('.header--container').clientHeight
                // Code... ^
                // Join idArray

                // Get element with id = 'id'

                if (id === '#home') {
                    setSmoothScrollTo(0, 0, 1000)
                }

                if (id !== '#contato') {
                    var targetOffset = (document.querySelector(id).offsetTop - (headerHeight + 50)) * 0.8
                    // Scroll animate
                    setSmoothScrollTo(0, targetOffset, 1000)
                } else {
                    var targetOffset = (document.querySelector(id).offsetTop) * 0.8
                    setSmoothScrollTo(0, targetOffset, 1000)
                }

            })
        })
    }
}